export const getUserFontName = (filename: string) => {
  const index = filename.lastIndexOf('.');
  return filename.slice(0, index);
};

export const getUserFontFileExtension = (filename: string) => {
  return filename.split('.').pop();
};
